import { useEffect } from 'react'

import Player from 'video.js/dist/types/player'

const MIN_BANDWIDTH = 1000000 * 7.5 // 5Mb

export const useMinBandwidth = (player: Player, onErrorCB: (message?: string) => void) => {
  const bandwidth = player.tech().hls?.bandwidth || player.tech().vhs?.bandwidth
  useEffect(() => {
    if (!bandwidth) return
    if (bandwidth < MIN_BANDWIDTH) {
      const errorMEssage = `VideoJS: Bandwidth calculated to be less than ${MIN_BANDWIDTH} thus disabling the video`
      console.error(errorMEssage)
      onErrorCB(errorMEssage)
    }
  }, [bandwidth])
}
